import { renderSelectPrompt } from '@shopify/cli-kit/node/ui';
import { SETUP_CSS_STRATEGIES } from './assets.js';
export { SETUP_CSS_STRATEGIES } from './assets.js';
import { setupTailwind } from './tailwind.js';
import { setupVanillaExtract } from './vanilla-extract.js';

const STYLING_CHOICES = [...SETUP_CSS_STRATEGIES, "none"];
const CSS_STRATEGY_NAME_MAP = {
  tailwind: "Tailwind v4",
  "vanilla-extract": "Vanilla Extract",
  "css-modules": "CSS Modules",
  postcss: "PostCSS"
};
const CSS_STRATEGY_HELP_URL_MAP = {
  postcss: "https://vitejs.dev/guide/features.html#postcss",
  "css-modules": "https://vitejs.dev/guide/features.html#css-modules",
  "vanilla-extract": "https://vanilla-extract.style/documentation/styling/",
  tailwind: "https://tailwindcss.com/docs/configuration"
};
function setupCssStrategy(strategy, options, force) {
  switch (strategy) {
    case "tailwind":
      return setupTailwind(options, force);
    case "vanilla-extract":
      return setupVanillaExtract(options);
    case "postcss":
    case "css-modules":
      return {
        workPromise: Promise.resolve(),
        generatedAssets: [],
        needsInstallDeps: false
      };
    default:
      throw new Error("Unknown strategy");
  }
}
async function renderCssPrompt(options) {
  const cssStrategies = Object.entries({
    ...CSS_STRATEGY_NAME_MAP,
    ...options?.extraChoices
  });
  return renderSelectPrompt({
    message: "Select a styling library",
    ...options,
    choices: cssStrategies.map(([value, label]) => ({
      value,
      label
    })),
    defaultValue: "tailwind"
  });
}

export { CSS_STRATEGY_HELP_URL_MAP, CSS_STRATEGY_NAME_MAP, STYLING_CHOICES, renderCssPrompt, setupCssStrategy };
